// The handful of strings a push notification can contain.
//
// Split out of the full dictionaries so the service worker can compose a
// notification without importing them. The worker is on the critical path of
// every launch — nothing renders until it has been parsed and evaluated — and
// two complete dictionaries is a lot of weight for nine sentences.
//
// These are not copies. en.ts and pl.ts spread them back in, so each string is
// still defined exactly once and the compiler still refuses a missing Polish
// translation. Adding a key that `typePreview` can reach means adding it HERE,
// not in the big files, or the worker will fall back to the generic wording.

export const pushEn = {
  'push.generic.title': 'Dialano',
  'push.generic.body': 'New messages',

  'el.cart.title': 'Cart',
  'el.order.title': 'Order',
  'el.payment.title': 'Payment request',

  'contact.cat.order_status': 'Order status',
  'contact.cat.reminder': 'Reminders',
  'contact.cat.outage': 'Outages',
  'contact.cat.other': 'Other',
} as const;

/** The push subset carries its own shape, so pl.ts cannot drift from en.ts here
 *  any more than it can in the full dictionary. */
export type PushDict = Record<keyof typeof pushEn, string>;

export const pushPl = {
  'push.generic.title': 'Dialano',
  'push.generic.body': 'Nowe wiadomości',

  'el.cart.title': 'Koszyk',
  'el.order.title': 'Zamówienie',
  'el.payment.title': 'Prośba o płatność',

  'contact.cat.order_status': 'Status zamówienia',
  'contact.cat.reminder': 'Przypomnienia',
  'contact.cat.outage': 'Awarie',
  'contact.cat.other': 'Inne',
} satisfies PushDict;
